import { render, staticRenderFns } from "./workload-list.vue?vue&type=template&id=f19adace&scoped=true&"
import script from "./workload-list.vue?vue&type=script&lang=js&"
export * from "./workload-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19adace",
  null
  
)

export default component.exports